import api from "./api";

const KEY = "yoyo_source";
const TTL = 30 * 24 * 3600 * 1000;
const RULES = [
  ["instagram", "instagram"], ["facebook", "facebook"], ["fb.", "facebook"], ["whatsapp", "whatsapp"],
  ["wa.me", "whatsapp"], ["google", "google"], ["tiktok", "tiktok"], ["partage", "partage"],
];

const match = (s) => (RULES.find(([k]) => s.includes(k)) || [])[1];

export function detectSource() {
  const params = new URLSearchParams(window.location.search);
  const utm = (params.get("utm_source") || params.get("src") || "").toLowerCase();
  const ua = navigator.userAgent || "";
  if (utm) return match(utm) || "autre";
  if (params.get("fbclid")) return "facebook";
  if (params.get("gclid")) return "google";
  if (/Instagram/i.test(ua)) return "instagram";
  if (/FBAN|FBAV|FB_IAB/i.test(ua)) return "facebook";
  if (/WhatsApp/i.test(ua)) return "whatsapp";
  if (/TikTok|musical_ly|Bytedance/i.test(ua)) return "tiktok";
  const ref = document.referrer || "";
  if (ref && !ref.includes(window.location.host)) return match(ref.toLowerCase()) || "autre";
  return "";
}

export function initSource() {
  if (sessionStorage.getItem("yoyo_visit")) return;
  sessionStorage.setItem("yoyo_visit", "1");
  const s = detectSource();
  if (s) localStorage.setItem(KEY, JSON.stringify({ s, at: Date.now() }));
  api.post("/visit", { source: s || "direct" }).catch(() => {});
}

export function getSource() {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || "null");
    return v && Date.now() - v.at < TTL ? v.s : "direct";
  } catch (e) {
    return "direct";
  }
}

export const SOURCE_LABELS = {
  instagram: "Instagram", facebook: "Facebook", whatsapp: "WhatsApp", google: "Google",
  tiktok: "TikTok", partage: "Partage d'un lien", autre: "Autre site", direct: "Accès direct",
};
